<template>
  <v-card :disabled="!active">
    <v-card-text class="pa-1">
      <div class="text-subtitle-2">
        <v-btn
          v-if="icon"
          depressed
          width="25"
          height="25"
          fab
          :color="`${color} lighten-5`"
          :to="link"
        >
          <v-icon small :color="color">{{ icon }}</v-icon>
        </v-btn>
        {{ label }}
      </div>
      <p class="text-h6 text--primary text-center mb-0">
        {{ numFormatter(data, 2) }}
      </p>
    </v-card-text>
    <v-card-actions>
      <v-spacer> </v-spacer>
      <DrillLink v-if="link" :to="link" text="See All" />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import { numFormatter } from "@/utils";
import DrillLink from "./DrillLink.vue";

export default Vue.extend({
  components: { DrillLink },
  name: "StatsCard",

  data() {
    return {};
  },
  props: {
    color: VueTypes.string.def("light-blue"),
    icon: VueTypes.string.def(""),
    label: VueTypes.string.def(""),
    link: VueTypes.string.def(""),
    data: VueTypes.number.def(0),
    active: VueTypes.bool.def(true),
  },
  methods: { numFormatter },
});
</script>
